import { PAGE_SIZE } from '../pagination/paginationConsts';
export const PLAYLIST_SEARCH_RESULTS_SIZE = PAGE_SIZE;